import { useNavigate, type NavigateFunction, useLocation } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect, useMemo } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });

  // 公开页面 URL 统一使用尾斜杠（如 /about/），但内部路由查找键保持无尾斜杠。
  // 这里仅在做路由匹配时去除尾斜杠，让直访 /about/ 也能命中 /about 路由，
  // 不影响 canonical/og:url 等 SEO 输出（SeoHead 依据真实 pathname 单独计算）。
  const matchLocation = useMemo(() => {
    const pathname = location.pathname;
    if (pathname === '/' || !pathname.endsWith('/')) return location;
    return { ...location, pathname: pathname.replace(/\/+$/, '') };
  }, [location]);

  const element = useRoutes(routes, matchLocation);
  return element;
}
